import { Box, Tab, Tabs } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import AveragedCalibrationsTable from "./averaged-calibration-table";
import {
  getBaseAveragedCalibrations,
  getBrandAveragedCalibrations,
  getManufacturerAveragedCalibrations,
  getModelAveragedCalibrations,
  removeAveragedCalibrationById,
} from "../utils/NetworkHanlder";
import ImportExportFileButtons from "../import-export/import-export-buttons";

export default function AveragedCalibrationsPage({ isDetailedData }) {
  const [rowsData, setRowsData] = useState([]);
  const [clickedOption, setClickedOption] = useState(0);

  const sortAll = (data) => {
    const sortedMain = [...data].sort((a, b) => a.id.localeCompare(b.id));

    return sortedMain.map((item) => {
      if (item.components) {
        item.components.sort((a, b) => {
          return a.deviceCalibration.id.localeCompare(b.deviceCalibration.id);
        });
      }
      return item;
    });
  };

  const getDataFromBackend = async () => {
    let data;
    switch (clickedOption) {
      case 0:
        data = await getBaseAveragedCalibrations();
        setRowsData(sortAll(data.data));
        break;
      case 1:
        data = await getManufacturerAveragedCalibrations();
        setRowsData(sortAll(data.data));
        break;
      case 2:
        data = await getBrandAveragedCalibrations();
        setRowsData(sortAll(data.data));
        break;
      case 3:
        data = await getModelAveragedCalibrations();
        setRowsData(sortAll(data.data));
        break;
      default:
        setRowsData([]);
    }
  };

  const handleChange = (event, newValue) => {
    setClickedOption(newValue);
  };

  const removeGroupHandler = (id) => {
    // removeAveragedCalibrationById(id);
    getDataFromBackend();
  };

  useEffect(() => {
    getDataFromBackend();
  }, [clickedOption]);

  return (
    <Box>
      <ImportExportFileButtons updateData={getDataFromBackend} />
      <Tabs
        value={clickedOption}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        aria-label="opcje uśrednionych kalibracji"
      >
        <Tab label="Bazowa" value={0} />
        <Tab label="Producent" value={1} />
        <Tab label="Marka" value={2} />
        <Tab label="Model" value={3} />
      </Tabs>

      <AveragedCalibrationsTable
        data={rowsData}
        clickedOption={clickedOption}
        removeGroupHandler={removeGroupHandler}
        updateData={getDataFromBackend}
        isDetailedData={isDetailedData}
      />
    </Box>
  );
}
